import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/userSlice";
import conferenceReducer from "../features/conferenceSlices";

export default configureStore({
    reducer: {
        user: userReducer,
        conference: conferenceReducer
    }
})